module.exports = __webpack_public_path__ + "media/components/theme/fonts/GT-Pressura-Bold-290f4e646afc53b710ee069cafc0f2b9.eot";